/** 分割线 */
import { memo, createElement } from 'react';
import classnames from 'classnames';
import { TextArea as AntdTextArea } from 'antd-mobile';
import "./index.scss";
const TextArea = props => /*#__PURE__*/createElement(AntdTextArea, {
  ...props,
  className: classnames(props.className, 'cc-textarea')
});
TextArea.displayName = 'cc-textarea';
export default /*#__PURE__*/memo(TextArea);